import moment from 'moment'

export const millisecondsToDuration = (milliseconds: undefined | number): undefined | string => {
  const m = moment.duration(milliseconds)
  let hours: any = m.hours()
  let minutes: any = m.minutes()

  if (!hours && !minutes) {
    return undefined
  } else {
    if (hours > 0) {
      hours = hours + 'h'
    } else {
      hours = 0 + 'h'
    }

    if (minutes > 0) {
      minutes = minutes + 'min'
    } else {
      minutes = 0 + 'min'
    }

    return `${hours} ${minutes}`
  }
}
